module.exports = __webpack_public_path__ + "img/bonon.8c73c6b5.jpg";